import type { Lead } from '../../../../shared/types';
import { locationMessage } from '../../../../shared/locationRepair';
import { currentPosition } from '../../data/geocode';
import { repairLocation } from '../../data/locationActions';
import { btn, field, input, linkBtn } from '../../ui/components';
import { h } from '../../ui/dom';

export const locationRepair = (lead: Lead): HTMLElement => {
  const message = h('p', { role: 'status' }, locationMessage(lead));
  const lat = input({ type: 'number', placeholder: 'Latitude', value: lead.lat == null ? '' : String(lead.lat) });
  const lng = input({ type: 'number', placeholder: 'Longitude', value: lead.lng == null ? '' : String(lead.lng) });
  lat.step = lng.step = 'any';
  let busy = false;
  const perform = async (pair?: { lat: number; lng: number }) => {
    if (busy) return;
    busy = true;
    try { await repairLocation(lead, pair); message.textContent = pair ? 'Location saved on this phone' : 'Saved; looking up location'; }
    catch (err) { message.textContent = err instanceof Error ? err.message : 'Could not save location'; }
    finally { busy = false; }
  };
  const retry = btn('Retry location', { onClick: () => void perform(), variant: 'subtle' });
  retry.disabled = lead.coordinate_source === 'manual' ||
    (lead.location_status === 'resolving' && !!lead.location_attempted_at && Date.now() - Date.parse(lead.location_attempted_at) < 120_000);
  return h('section', { class: 'card', 'aria-label': 'Business location' }, message,
    linkBtn('Correct street, city and ZIP', `#/leads/${encodeURIComponent(lead.id)}/edit`), retry,
    h('details', {}, h('summary', {}, 'Confirm location manually'),
      h('p', {}, 'Confirm the business door before placing it. Place search unavailable; add address manually.'),
      field('Latitude', lat), field('Longitude', lng),
      btn('Save coordinates', { onClick: () => {
        const pair = { lat: Number(lat.value), lng: Number(lng.value) };
        if (!lat.value.trim() || !lng.value.trim() || !Number.isFinite(pair.lat) || !Number.isFinite(pair.lng) || Math.abs(pair.lat) > 90 || Math.abs(pair.lng) > 180) {
          message.textContent = 'Enter a valid latitude and longitude'; return;
        }
        void perform(pair);
      } }),
      btn('Use my current location', { onClick: () => { void currentPosition().then((point) => {
        if (!point) { message.textContent = 'Device location unavailable'; return; }
        lat.value = String(point.lat); lng.value = String(point.lng);
        message.textContent = 'Check these coordinates are the business door, then Save coordinates.';
      }); } }),
    ),
  );
};
